import { useState } from 'react';
import { Modal } from 'components/modal/Modal';
import PDFViewer from 'components/pdf/PDFViewer';

type Props = {
    close(): void;
    onAccept: () => void;
};

const ServiceFeeTermsModal = ({ close, onAccept }: Props) => {
    const [isScrolledToEnd, setIsScrolledToEnd] = useState(false);

    return (
        <Modal
            title="Service Fee Terms & Conditions"
            onCloseModal={close}
            secondaryButton="Cancel"
            handleSecondary={close}
            primaryButton="I Understand & Agree"
            handlePrimary={onAccept}
            disablePrimary={!isScrolledToEnd}
        >
            <PDFViewer
                fileUrl="/pdfs/75PillarsServiceFeeTerms.pdf"
                setIsScrolledToEnd={setIsScrolledToEnd}
                showPageBreaks
                containerHeightPx={480}
            />
            <p style={{ color: 'red', fontSize: 12, minHeight: 20 }}>
                {!isScrolledToEnd && 'Please read through the entire document to continue.'}
            </p>
        </Modal>
    );
};

export default ServiceFeeTermsModal;
